<template>
  <div class="opple-config-platform">
    <div class="opple-config-platform_header">
      <div class="opple-config-platform_header_title">
        <i class="el-icon-info" />
        <span>{{ title }}</span>
      </div>
      <TopBar
        ref="Platform"
        :device="device"
        :is-delete-loading="isDeleteLoading"
        :select-type-mode="selectTypeMode"
        :show-delete="deviceCardList.length > 0"
        :show-add="true"
        :add-disable="!showAdd"
        :show-cancel="selectType !== 0"
        @selectAll="selectAll"
        @showDeviceDialog="showDeviceDialog"
        @deleteDevice="onDeleteDevice"
        @onCancel="onCancel"
      />
    </div>

    <div class="opple-config-platform_list">
      <i v-if="isAddLoading" class="el-icon-loading" />
      <div v-if="!isAddLoading && deviceCardList.length === 0" class="opple-config-platform_list-noData">
        <img :src="noData">
        <p>{{ showAdd1 ? $t('adddevice.noDeviceTitle') : $t('adddevice.noDevice') }}</p>
      </div>
      <template v-if="!isAddLoading && deviceCardList.length !== 0">
        <OppleDeviceCard
          v-for="(card, index) in deviceCardList"
          :key="index"
          :data="card"
          :select-type="selectType"
          @select="onSelect"
        />
      </template>
    </div>
    <el-dialog
      :visible="isDeviceDialogVisable"
      class="dialogGroup choose_device midSecret"
      :before-close="hideDeviceDialog"
      top="0"
      append-to-body
    >
      <op-device-choose
        v-if="isDeviceDialogVisable"
        ref="opDeviceChoose"
        class="content"
        :is_group="false"
        :areaid="gpNo"
        :area-tree-type="1"
        :execute-type="2"
        :displaynoarea="true"
        :triggledevice="true"
        :is-ifttt="true"
        :get-device-list-fn="getDeviceListFn"
        :checkeddata="checkeddata"
        :required-max-device="true"
        :max-device="max"
        :has-select-device="deviceCardList.length"
        :hide-tree="hideTree"
        @confirm="addRelation"
      />
    </el-dialog>
  </div>
</template>

<script>
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue'
// import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import TopBar from './TopBar.vue'
import noData from '@/assets/img/no-data.png'
import { AddDeviceRelation, GetRelationDeviceList, RemoveDeviceRelation } from '@/axios/IMonitor.js'
import { FindDeviceListByPage, SetBLEProxy, GetBLEProxyDeviceList, GetCanBecomeBLEProxiesDeviceList } from '@/axios/IDevice.js'

export const isMidSecretLink = config => {
  const GpDetails = config.GpDetails || []

  return !!GpDetails.find(item => item.KeyId === 222 && item.IsShow)
}

export default {
  name: 'OppleConfigPlatform',
  components: {
    OppleDeviceCard,
    // OpDeviceChoose,
    TopBar,
  },
  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
    gpList: {
      type: Array,
      default: () => [],
    },
    gpDetails: {
      type: Object,
      default: () => ({}),
    },
    hideTree: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    console.log('.....hideTree', this.hideTree)
    return {
      checkeddata: [],
      gpNo: -1,
      currentTab: 0,
      isAddLoading: false,
      isDeleteLoading: false,
      isDeviceDialogVisable: false,
      deviceCardList: [],
      selectTypeMode: 1,
      noData,
      max: '',
      title: this.$t('adddevice.addMaxDeviceTitle').replace('{{max}}', ``),
      showAdd: true, //是否显示可添加
      showAdd1: false, //是否显示暂无设备支持中继节点
      showCancel: false,
      selectType: 0,
    }
  },

  computed: {},

  watch: {
    device(value) {
      this.requestBLEProxyDeviceList()
      // setTimeout(() => {
      //   this.deviceValueChange();
      // }, 1000)

      // this.setCom();
    },
    gpList() {},
  },

  mounted() {
    this.requestBLEProxyDeviceList()
    this.getDeviceListFn()
  },

  methods: {
    async getDeviceListFn(para, callback) {
      try {
        const res = await GetCanBecomeBLEProxiesDeviceList({
          pageIndex: 1,
          pageSize: 999,
          setType: 128,
          gpNos: para?.gpNos,
        })

        const RecordList = (res.Result || {}).RecordList || []
        this.showAdd1 = RecordList.length === 0
        callback &&
          callback(
            {
              StatusCode: res.StatusCode,
              Result: {
                RecordList,
                PageCount: 1,
                PageIndex: 1,
                PageSize: 30000,
                PanelCount: 0,
                SensorCount: 0,
                GatewayCount: RecordList.length,
                TotalCount: RecordList.length,
              },
            },
            {
              pageIndex: 1,
            }
          )
      } catch (e) {}
    },

    async requestBLEProxyDeviceList() {
      try {
        if (this.gpDetails && this.gpDetails.GpDetails && Array.isArray(this.gpDetails.GpDetails) && this.gpDetails.GpDetails.length > 0) {
          this.max = this.gpDetails.GpDetails[0].Max
          this.title = this.$t('adddevice.addMaxDeviceTitle').replace('{{max}}', this.max)
        }
        const res = await GetBLEProxyDeviceList({
          proxiedDeviceId: this.device.DeviceId,
        })

        const list = res.Result || []
        // .map(item => {
        //   const info = item.StatusInfo || '{}';
        //   return {
        //     ...item,
        //     StatusInfo: JSON.parse(info)
        //   }
        // });

        this.deviceCardList = list
        // // 不选择这个设备本身 因为设备不能关联自己
        this.checkeddata = [...list]

        if (this.max !== '' && list.length < this.max) {
          this.showAdd = true
        } else {
          this.showAdd = false
        }
      } catch (e) {}
    },

    onItemClick(tab) {
      this.currentTab = tab
    },

    selectAll() {
      if (this.selectType === 0) {
        return
      }
      if (this.selectTypeMode === 1) {
        this.deviceCardList = this.deviceCardList.map(item => ({ ...item, checked: true }))
      } else {
        this.deviceCardList = this.deviceCardList.map(item => ({ ...item, checked: false }))
      }

      this.selectTypeMode = this.selectTypeMode === 1 ? 0 : 1
    },

    onSelect(data, isCheck) {
      if (this.selectType === 1) {
        this.deviceCardList = this.deviceCardList.map(item => {
          if (item.ClassSku === data.ClassSku && item.VDeviceId === data.VDeviceId) {
            return {
              ...item,
              checked: isCheck,
            }
          }

          return {
            ...item,
            // checked: !!isCheck ? false : item.checked
          }
        })
      }
      console.log('data', data, isCheck, this.deviceCardList)
    },
    showDeviceDialog() {
      this.isDeviceDialogVisable = true
    },
    hideDeviceDialog() {
       //将body上有一个clas叫v-modal的元素去掉
      var body = document.getElementsByTagName('body')[0];
      var modal = document.getElementsByClassName('v-modal')[0];
      if (modal &&  modal.parentNode === body) {
        body.removeChild(modal);
      } else {
        console.warn('Modal is not a child of body or does not exist.');
      }
      this.isDeviceDialogVisable = false
    },

    addRelation(devices) {
      this.deviceValueChange(devices, true)
    },

    async onDeleteDevice() {
      if (this.selectType === 0) {
        this.selectType = 1
        return
      }
      // 排除设备自己
      const checkeddata = this.deviceCardList.filter(device => !!device.checked)

      if (checkeddata.length === 0) {
        this.$message({
          type: 'warning',
          message: this.$t('monitor.select'),
        })
        return
      }

      this.deviceValueChange(checkeddata, false)
    },
    onCancel() {
      this.selectTypeMode = 0
      this.selectAll()
      this.selectType = 0
    },

    deleteRelation(devices) {
      this.deviceValueChange(devices, false)
    },

    /**
     * IsEnable 增加为true, 删除为false
     */
    async deviceValueChange(devices, IsEnable) {
      const GpDetails = this.gpList[0].GpDetails || []

      const SecretData = GpDetails.find(item => item.KeyId === 223) || {}
      const Secret = SecretData.DefaultValue

      const params = {
        ProxiedDeviceList: [
          {
            IsEnable,
            DeviceId: this.device.DeviceId,
            Mac: this.device.Mac,
            Secret,
            MaxCount: this.max,
          },
        ],
        DeviceIdList: devices.map(item => item.VDeviceId),
      }

      console.log('deviceValueChange', this.gpList, params)
      // return;
      try {
        // this.isAddLoading = true;

        // this.hideDeviceDialog();

        const res = await SetBLEProxy(params)

        await this.requestBLEProxyDeviceList()
        this.getDeviceListFn()
        if (IsEnable === false) {
          this.selectTypeMode = 1
        }
        this.selectType = 0
        this.isAddLoading = false
        this.hideDeviceDialog()
      } catch (e) {
        this.isAddLoading = false
      }
      // console.log('devlices', relativeDevices);
    },
  },
}
</script>

<style lang="scss" scoped>
.opple-config-platform {
  flex: 1;
  &_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    ::v-deep .opple-config-topBar {
      flex-shrink: 0;
    }

    &_title {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #8c8c8c;
        display: block;
        word-break: break-word;
      }
      i {
        font-size: 16px;
        color: #8c8c8c;
        margin-right: 5px;
      }
    }
  }
  &_list {
    display: flex;
    flex-wrap: wrap;

    &-noData {
      margin: 0 auto;
      width: 100%;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #9e9e9e;

      img {
        width: 280px;
        margin-bottom: 10px;
      }
    }

    .el-icon-loading {
      margin: 10px 100px;
    }
  }

  .opple-device-card {
    margin: 10px;
  }
}
.midSecret ::v-deep .el-dialog__body {
  padding: 20px 0px;
}
</style>
